import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex justify-between items-center h-16">
        
        {/* Logo (Uses locally hosted Azure image) */}
		
<div>
  <Link to="/">
    <img 
      src="/Logo.png"  
      alt="Logo" 
      className="h-12 object-contain hover:opacity-80 rounded-md"
    />
  </Link>
</div>

		
   

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/pricing" className="nav-link">Preise</Link>
          <Link to="/api-docs" className="nav-link">API Docs</Link>
          <Link to="/kontakt" className="nav-link">Kontakt</Link>
          <Link to="/impressum" className="nav-link">Impressum</Link>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-900 focus:outline-none">
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg absolute w-full top-16 left-0 p-4 flex flex-col space-y-2">
          <Link to="/" className="text-lg text-gray-900" onClick={() => setIsOpen(false)}>Home</Link>
          <Link to="/pricing" className="text-lg text-gray-900" onClick={() => setIsOpen(false)}>Preise</Link>
          <Link to="/api-docs" className="text-lg text-gray-900" onClick={() => setIsOpen(false)}>API Docs</Link>
          <Link to="/kontakt" className="text-lg text-gray-900" onClick={() => setIsOpen(false)}>Kontakt</Link>
          <Link to="/impressum" className="text-lg text-gray-900" onClick={() => setIsOpen(false)}>Impressum</Link>
        </div>
      )}
    </nav>
  );
}
